<template>
  <v-container grid-list-lg>
    <v-layout flex align-center justify-center row wrap>
      <v-flex xs12>
        <v-toolbar height="56" color="primary">
          <v-toolbar-title
            id="idCabecalhoJanela"
            class="subheading white--text"
          >
            Editar Perfil
          </v-toolbar-title>
        </v-toolbar>
        <v-card>
          <v-card-text>
            <v-container grid-list-lg>
              <v-form
                ref="formCadastroPerfil"
                v-model="formValidCadastroPerfil"
              >
                <v-layout row wrap>
                  <v-flex xs12 sm4>
                    <v-text-field
                      label="Tipo de Perfil*"
                      id="txtCadastroPerfilTipo"
                      ref="txtCadastroPerfilTipoRef"
                      v-model="perfilModel.descricao"
                      @change="validaDescricaoPerfil()"
                      :rules="
                        formRulesComputed.perfil.descricao(
                          perfilModel.descricao,
                          descricaoDePerfilValida
                        )
                      "
                      disabled
                    ></v-text-field>
                  </v-flex>
                  <!-- <v-spacer></v-spacer> -->
                  <v-flex xs12 sm2>
                    <v-select
                      label="Status*"
                      id="txtCadastroPerfilStatus"
                      ref="txtCadastroPerfilStatusRef"
                      v-model="perfilModel.ativo"
                      :items="[
                        { text: 'Ativo', value: true },
                        { text: 'Inativo', value: false },
                      ]"
                      item-text="text"
                      item-value="value"
                      :disabled="perfilAdministradorEmEdicao"
                      :rules="
                        formRulesComputed.perfil.status(perfilModel.ativo)
                      "
                    ></v-select>
                  </v-flex>

                  <v-layout row wrap class="permissaotableflex">
                    <v-flex xs12 class="permissaotableflexcontent">
                      <v-data-table
                        v-model="permissoesSelecionadas"
                        :headers="headers"
                        :items="permissaoList"
                        :loading="loadingPermissoes"
                        rows-per-page-text="Linhas por página"
                        :rows-per-page-items="[
                          10,
                          20,
                          { text: 'Todas', value: -1 },
                        ]"
                        item-key="id"
                        class="elevation-0"
                      >
                        <v-progress-linear
                          slot="progress"
                          color="primary"
                          indeterminate
                        ></v-progress-linear>
                        <template slot="items" slot-scope="props">
                          <td>
                            {{ props.item.titulo }}
                          </td>

                          <td class="d-inline-flex align-center pa-1">
                            <v-checkbox
                              v-model="props.item.seguros.checked"
                              color="primary"
                              primary
                              hide-details
                              :disabled="perfilAdministradorEmEdicao"
                            ></v-checkbox>
                            <p class="mb-0 mr-2">Apisul Seguros</p>

                            <v-checkbox
                              v-model="props.item.frotas.checked"
                              color="primary"
                              primary
                              hide-details
                              :disabled="perfilAdministradorEmEdicao"
                            ></v-checkbox>
                            <p class="mb-0">Apisul Frota</p>
                          </td>

                          <td>{{ props.item.descricao }}</td>
                        </template>
                        <v-flex
                          slot="no-data"
                          :value="true"
                          class="text-xs-center"
                        >
                          Nenhuma permissão carregada.
                        </v-flex>
                        <v-flex
                          slot="no-results"
                          :value="true"
                          class="text-xs-center"
                        >
                          Sua busca por "{{ filtro }}" não encontrou resultados.
                        </v-flex>
                        <template slot="pageText" slot-scope="props">
                          {{ props.pageStart }} - {{ props.pageStop }} de
                          {{ props.itemsLength }}
                        </template>
                      </v-data-table>
                    </v-flex>
                  </v-layout>
                </v-layout>
              </v-form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 mt-4>
        <v-btn
          text-md-left
          text-xs-center
          id="btnVoltarCadastroPerfil"
          ref="btnVoltarCadastroPerfilRef"
          :block="$vuetify.breakpoint.xsOnly"
          class="white--text left"
          @click.native="go('GestaoPerfil')"
          color="primary"
          flat
        >
          Voltar
        </v-btn>
        <v-btn
          text-md-right
          text-xs-center
          :disabled="
            !descricaoDePerfilValida || !modificados.length || loadingSalvar
          "
          id="btnSalvarCadastroPerfil"
          ref="btnSalvarCadastroPerfilRef"
          :block="$vuetify.breakpoint.xsOnly"
          :loading="loadingSalvar"
          class="white--text right"
          @click.native="salvarPerfil()"
          color="primary"
        >
          Salvar
          <v-icon right class="hidden-sm-and-down">save</v-icon>
        </v-btn>
      </v-flex>
      <v-snackbar
        :timeout="6000"
        :color="snackbar.sucesso ? 'success' : 'error'"
        multi-line
        v-model="snackbar.visivel"
      >
        {{ snackbar.mensagem }}
        <v-btn dark flat @click.native="snackbar.visivel = false">Fechar</v-btn>
      </v-snackbar>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
import auditoria from "@/helpers/auditoria";
import { arrayIsEqual } from "@/helpers/comparadores";
import formRules from "@/helpers/form-rules";
import perfil from "@/helpers/perfil";
import usuarioHelper from "@/helpers/usuario-logado";

export default {
  name: "CadastroPerfil",
  data: () => {
    return {
      permissoesSelecionadas: [],
      loadingPermissoes: false,
      mostraDialog: false,
      filtro: "",
      headers: [
        { text: "TÍTULO", value: "titulo" },
        {
          text: "PLATAFORMA DE ACESSO",
          value: "plataformaDeAcesso",
          sortable: false,
        },
        { text: "DESCRIÇÃO", value: "descricao" },
      ],
      formValidCadastroPerfil: false,
      descricaoDePerfilValida: true,
      loadingSalvar: false,
      permissaoList: [],
      perfilEmEdicao: null,
      perfilModel: {
        id: null,
        descricao: null,
        ativo: true,
      },
      snackbar: {
        visivel: false,
        sucesso: false,
        mensagem: "",
      },
    };
  },
  computed: {
    formRulesComputed: function () {
      return formRules;
    },
    perfilComputed: function () {
      return perfil;
    },
    modoEdicao: function () {
      return this.$route.params.id;
    },
    houveModificacao: function () {
      if (this.perfilEmEdicao) {
        if (
          !arrayIsEqual(
            this.perfilEmEdicao.permissoes,
            this.permissoesSelecionadas
          ) ||
          this.perfilEmEdicao.ativo != this.perfilModel.ativo
        ) {
          return true;
        }
      }
      return false;
    },
    perfilAdministradorEmEdicao: function () {
      if (!this.perfilEmEdicao) {
        return true;
      }
      return this.perfilEmEdicao.id == this.perfilComputed.ADMINISTRADOR;
    },
    modificados() {
      const permissoesModificadas = [];
      this.permissaoList.forEach((item) => {
        ["frotas", "seguros"].forEach((subItem) => {
          if (
            item[subItem] &&
            item[subItem].checked !== item[subItem].default
          ) {
            permissoesModificadas.push({ id: item[subItem].id });
          }
        });
      });
      return permissoesModificadas;
    },
  },
  mounted: function () {
    if (!this.$route.params.id) {
      this.go("GestaoPerfil", {
        snackbarText: "Ocorreu um erro ao buscar o perfil",
        snackbarMostrar: true,
        snackbarSucesso: false,
      });
    }

    this.buscaPerfil();
    // this.permissaoList = this.convertPermissao(this.permissaoListTest);
  },
  methods: {
    validaDescricaoPerfil: function () {
      const self = this;
      self.$store.commit("startLoading");
      axios
        .get(
          `${process.env.URL_USUARIOMS}/v1/validaDescricaoDePerfil?descricao=${self.perfilModel.descricao}`,
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`,
            },
          }
        )
        .then((response) => {
          self.descricaoDePerfilValida = response.data;
          self.$store.commit("endLoading");
        })
        .catch((err) => {
          self.$store.commit("endLoading");
          self.snackbar.visivel = true;
          self.snackbar.sucesso = false;
          self.snackbar.mensagem = "Ocorreu um erro ao validar o nome do grupo";
        });
    },
    buscaPerfil: function () {
      const self = this;
      self.$store.commit("startLoading");
      axios
        .get(
          `${process.env.URL_USUARIOMS}/v1/buscaPerfilPorId?id=${this.$route.params.id}`,
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`,
            },
          }
        )
        .then((response) => {
          const data = response.data;
          self.perfilModel = data;
          self.perfilEmEdicao = JSON.parse(JSON.stringify(self.perfilModel));
          if (self.perfilModel.permissoes) {
            self.permissoesSelecionadas = self.perfilModel.permissoes.slice();
          }
          this.buscaPermissoes();
          self.$store.commit("endLoading");
        })
        .catch((err) => {
          self.$store.commit("endLoading");
          self.snackbar.visivel = true;
          self.snackbar.sucesso = false;
          self.snackbar.mensagem = "Ocorreu um erro ao buscar o perfil";
        });
    },
    buscaPermissoes: function () {
      const self = this;
      self.$store.commit("startLoading");
      axios
        .get(`${process.env.URL_USUARIOMS}/v1/buscaPermissoes`, {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`,
          },
        })
        .then((response) => {
          self.permissaoList = this.convertPermissao(response.data);

          self.$store.commit("endLoading");
        })
        .catch((err) => {
          self.$store.commit("endLoading");
          self.snackbar.visivel = true;
          self.snackbar.sucesso = false;
          self.snackbar.mensagem = "Ocorreu um erro ao buscar as permissões";
        });
    },
    salvarPerfil: function () {
      const self = this;
      self.$store.commit("startLoading");
      self.loadingSalvar = true;
      self.perfilModel = self.gerarPerfilModel();

      axios
        .post(
          `${process.env.URL_USUARIOMS}/v1/cadastraPerfil`,
          self.perfilModel,
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`,
            },
          }
        )
        .then((response) => {
          auditoria.registrar(self.montaStringDescricaoAuditoria(), "", "");
          self.loadingSalvar = false;
          self.$store.commit("endLoading");
          self.go("GestaoPerfil", {
            snackbarText: this.modoEdicao
              ? "Perfil editado com sucesso"
              : "Perfil criado com sucesso",
            snackbarMostrar: true,
            snackbarSucesso: true,
          });
        })
        .catch((erro) => {
          console.log(erro);
          self.$store.commit("endLoading");
          self.loadingSalvar = false;
          self.snackbar.mensagem = "Não foi possível completar a operação.";
          self.snackbar.sucesso = false;
          self.snackbar.visivel = true;
        });
    },
    montaStringDescricaoAuditoria: function () {
      const self = this;
      if (!self.perfilEmEdicao) {
        return `Cadastrado perfil: ${self.perfilModel.descricao}`;
      } else {
        var mensagem = `Alterado perfil: ${self.perfilEmEdicao.descricao}. `;

        if (self.perfilModel.descricao != self.perfilEmEdicao.descricao) {
          mensagem += `Nova descrição: ${self.perfilModel.descricao}. `;
        }
        if (self.perfilModel.ativo != self.perfilEmEdicao.ativo) {
          mensagem += `Novo Status: ${
            self.perfilModel.ativo ? "Ativo" : "Inativo"
          }. `;
        }
        if (
          !arrayIsEqual(
            self.perfilEmEdicao.permissoes,
            self.perfilModel.permissoes
          )
        ) {
          mensagem += `Alteração lista de permissões `;
        }
      }
      return mensagem;
    },
    go: function (routeName, routeParams) {
      const self = this;
      if (!routeParams) {
        self.$router.push({ name: routeName });
      } else {
        self.$router.push({ name: routeName, params: routeParams });
      }
    },
    convertPermissao(permissoes) {
      if (!(permissoes instanceof Array)) {
        return [];
      }
      const permissoesFrontEnd = [];
      permissoes.forEach((item) => {
        const selecionada = !!this.permissoesSelecionadas.find(
          (subItem) => subItem.id === item.id
        );
        const plataforma = {};
        if (item.plataforma.id === 1) {
          plataforma.seguros = {
            id: item.id,
            checked: selecionada,
            default: selecionada,
          };
        } else if (item.plataforma.id === 2) {
          plataforma.frotas = {
            id: item.id,
            checked: selecionada,
            default: selecionada,
          };
        } else {
          return;
        }
        const index = permissoesFrontEnd.findIndex(
          (subItem) => subItem.id === item.permissaoInfo.id
        );
        if (index === -1) {
          permissoesFrontEnd.push({
            id: item.permissaoInfo.id,
            titulo: item.permissaoInfo.titulo,
            descricao: item.permissaoInfo.descricao,
            ...plataforma,
          });
        } else {
          permissoesFrontEnd[index] = {
            ...permissoesFrontEnd[index],
            ...plataforma,
          };
        }
      });
      return permissoesFrontEnd;
    },
    gerarPerfilModel() {
      return {
        ...this.perfilModel,
        permissoes: this.pegarModificados(),
      };
    },
    pegarModificados() {
      const modificados = [];
      this.permissaoList.forEach((item) => {
        if (item.seguros && item.seguros.checked) {
          modificados.push({ id: item.seguros.id });
        }
        if (item.frotas && item.frotas.checked) {
          modificados.push({ id: item.frotas.id });
        }
      });
      return modificados;
    },
  },
};
</script>

<style scoped>
.permissaotableflex {
  overflow-x: auto;
}
.permissaotableflexcontent {
  min-width: 800px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/perfil/CadastroPerfil.vue